<template>
  <main class="skillcertify">
    <section class="sub-hero has-visual">
      <div class="hero-wrap">
        <div class="hero-row">
          <div class="sub-hero-copy">
            <p class="tag" data-i18n="skillcertify-hero-eyebrow" v-html="$rt('skillcertify-hero-eyebrow')"></p>
            <h1 class="hero-title">SkillCertify</h1>
            <p class="hero-desc" data-i18n="skillcertify-hero-desc-01" v-html="$rt('skillcertify-hero-desc-01')"></p>
            <p class="hero-desc" data-i18n="skillcertify-hero-desc-02" v-html="$rt('skillcertify-hero-desc-02')"></p>
            <div class="hero-actions">
              <a class="btn btn-primary btn-lg" href="https://codepresso.io/home/contact">
                <span data-i18n="skillcertify-hero-cta" v-html="$rt('skillcertify-hero-cta')"></span>
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
              </a>
            </div>
          </div>
        </div>
        <div class="hero-visual" role="img" aria-label="SkillCertify 평가 화면 예시 — 응시자 프로필과 채점 결과 요약, 코드 에디터"></div>
      </div>
    </section>

    <section class="intro pain-section fade-up">
      <div class="section-wrap col">
        <div class="section-title text-center">
          <h3 data-i18n="skillcertify-intro-title" v-html="$rt('skillcertify-intro-title')"></h3>
        </div>
        <div class="section-content">
          <ul class="pain-grid">
            <li class="pain-card" data-i18n="skillcertify-intro-item-01" v-html="$rt('skillcertify-intro-item-01')"></li>
            <li class="pain-card" data-i18n="skillcertify-intro-item-02" v-html="$rt('skillcertify-intro-item-02')"></li>
            <li class="pain-card" data-i18n="skillcertify-intro-item-03" v-html="$rt('skillcertify-intro-item-03')"></li>
          </ul>
        </div>
      </div>
    </section>

    <section class="deliverables product-feature is-sunken fade-up">
      <div class="section-wrap row">
        <div class="feature-copy">
          <p class="tag" data-i18n="skillcertify-deliverables-tag-01" v-html="$rt('skillcertify-deliverables-tag-01')"></p>
          <h2 data-i18n="skillcertify-deliverables-title-01" v-html="$rt('skillcertify-deliverables-title-01')"></h2>
          <ul class="feature-points">
            <li>
              <img src="/images/icons/service/ic_check_round.svg" alt="" aria-hidden="true">
              <span data-i18n="skillcertify-deliverables-point-01-01" v-html="$rt('skillcertify-deliverables-point-01-01')"></span>
            </li>
            <li>
              <img src="/images/icons/service/ic_check_round.svg" alt="" aria-hidden="true">
              <span data-i18n="skillcertify-deliverables-point-01-02" v-html="$rt('skillcertify-deliverables-point-01-02')"></span>
            </li>
          </ul>
        </div>
        <div class="content-panel bg">
          <img src="/images/products/skillcertify/screens/sub_1_certify_1.CtJcntr5.svg" alt="실무 프로젝트 화면 예시 — 백엔드 개발자 과제 화면과 코드 에디터">
        </div>
      </div>
    </section>

    <section class="deliverables product-feature fade-up">
      <div class="section-wrap row">
        <div class="feature-copy">
          <p class="tag" data-i18n="skillcertify-deliverables-tag-02" v-html="$rt('skillcertify-deliverables-tag-02')"></p>
          <h2 data-i18n="skillcertify-deliverables-title-02" v-html="$rt('skillcertify-deliverables-title-02')"></h2>
          <ul class="feature-points">
            <li>
              <img src="/images/icons/service/ic_check_round.svg" alt="" aria-hidden="true">
              <span data-i18n="skillcertify-deliverables-point-02-01" v-html="$rt('skillcertify-deliverables-point-02-01')"></span>
            </li>
            <li>
              <img src="/images/icons/service/ic_check_round.svg" alt="" aria-hidden="true">
              <span data-i18n="skillcertify-deliverables-point-02-02" v-html="$rt('skillcertify-deliverables-point-02-02')"></span>
            </li>
          </ul>
        </div>
        <div class="content-panel bg">
          <img src="/images/products/skillcertify/screens/sub_1_certify_2.Bs5PuAs2.svg" alt="채점 리포트 화면 예시 — 지원자 답안과 정답 코드를 나란히 비교하는 화면">
        </div>
      </div>
    </section>

    <section class="deliverables product-feature is-sunken fade-up">
      <div class="section-wrap row">
        <div class="feature-copy">
          <p class="tag" data-i18n="skillcertify-deliverables-tag-03" v-html="$rt('skillcertify-deliverables-tag-03')"></p>
          <h2 data-i18n="skillcertify-deliverables-title-03" v-html="$rt('skillcertify-deliverables-title-03')"></h2>
          <ul class="feature-points">
            <li>
              <img src="/images/icons/service/ic_check_round.svg" alt="" aria-hidden="true">
              <span data-i18n="skillcertify-deliverables-point-03-01" v-html="$rt('skillcertify-deliverables-point-03-01')"></span>
            </li>
            <li>
              <img src="/images/icons/service/ic_check_round.svg" alt="" aria-hidden="true">
              <span data-i18n="skillcertify-deliverables-point-03-02" v-html="$rt('skillcertify-deliverables-point-03-02')"></span>
            </li>
          </ul>
        </div>
        <div class="content-panel bg">
          <img src="/images/products/skillcertify/screens/sub_1_certify_3.CzB0bdcf.svg" alt="평가 카탈로그 화면 예시 — 직무 트랙과 난이도(Level)를 선택해 평가를 구성하는 화면">
        </div>
      </div>
    </section>

    <section class="deliverables product-feature fade-up">
      <div class="section-wrap row">
        <div class="feature-copy">
          <p class="tag" data-i18n="skillcertify-deliverables-tag-04" v-html="$rt('skillcertify-deliverables-tag-04')"></p>
          <h2 data-i18n="skillcertify-deliverables-title-04" v-html="$rt('skillcertify-deliverables-title-04')"></h2>
          <ul class="feature-points">
            <li>
              <img src="/images/icons/service/ic_check_round.svg" alt="" aria-hidden="true">
              <span data-i18n="skillcertify-deliverables-point-04-01" v-html="$rt('skillcertify-deliverables-point-04-01')"></span>
            </li>
            <li>
              <img src="/images/icons/service/ic_check_round.svg" alt="" aria-hidden="true">
              <span data-i18n="skillcertify-deliverables-point-04-02" v-html="$rt('skillcertify-deliverables-point-04-02')"></span>
            </li>
          </ul>
        </div>
        <div class="content-panel bg">
          <img src="/images/products/skillcertify/screens/sub_1_certify_4.CJGUkdYE.svg" alt="감독 경고 화면 예시 — 화면 이탈·복사붙여넣기 등 이상 행동이 감지되어 관리자에게 보고된다는 경고 팝업">
        </div>
      </div>
    </section>

    <section class="process fade-up">
      <div class="section-wrap col">
        <div class="section-title text-center">
          <p class="mini-title" data-i18n="skillcertify-process-tag" v-html="$rt('skillcertify-process-tag')"></p>
          <h2 data-i18n="skillcertify-process-title" v-html="$rt('skillcertify-process-title')"></h2>
          <p class="desc" data-i18n="skillcertify-process-desc" v-html="$rt('skillcertify-process-desc')"></p>
        </div>
        <div class="section-content">
          <ol class="cycle">
            <li class="blue">
              <span class="cycle-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15.86 3.65039L19.4 7.19038L7.90999 18.6704L4 19.0004L4.37999 15.1404L15.86 3.65039Z" fill="var(--color-brand)" fill-opacity=".35"></path>
                  <path d="M18.0498 8.54065L14.5098 5.00064L16.6398 2.88065C16.8271 2.69439 17.0806 2.58984 17.3448 2.58984C17.6089 2.58984 17.8624 2.69439 18.0498 2.88065L20.1698 5.00064C20.2635 5.0936 20.3379 5.20419 20.3887 5.32605C20.4394 5.44791 20.4656 5.57862 20.4656 5.71063C20.4656 5.84264 20.4394 5.97336 20.3887 6.09521C20.3379 6.21707 20.2635 6.32766 20.1698 6.42062L18.0498 8.54065Z" fill="var(--color-brand)" fill-opacity=".35"></path>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M3 21C3 20.4477 3.44772 20 4 20H20C20.5523 20 21 20.4477 21 21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21Z" fill="var(--color-brand)"></path>
                </svg>
              </span>
              <div class="cycle-body">
                <h4 data-i18n="skillcertify-process-item-title-01" v-html="$rt('skillcertify-process-item-title-01')"></h4>
                <p class="desc-sm" data-i18n="skillcertify-process-item-desc-01" v-html="$rt('skillcertify-process-item-desc-01')"></p>
              </div>
              <span class="cycle-arrow" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
              </span>
            </li>
            <li class="blue">
              <span class="cycle-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 4H4C2.89543 4 2 4.89543 2 6V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V6C22 4.89543 21.1046 4 20 4Z" fill="var(--color-brand)" fill-opacity=".35"></path>
                  <path d="M22 6.5H2V9.5H22V6.5Z" fill="var(--color-brand)"></path>
                  <path d="M20 11H4V14H20V11Z" fill="var(--color-brand-tint-2)"></path>
                </svg>
              </span>
              <div class="cycle-body">
                <h4 data-i18n="skillcertify-process-item-title-02" v-html="$rt('skillcertify-process-item-title-02')"></h4>
                <p class="desc-sm" data-i18n="skillcertify-process-item-desc-02" v-html="$rt('skillcertify-process-item-desc-02')"></p>
              </div>
              <span class="cycle-arrow" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
              </span>
            </li>
            <li class="blue">
              <span class="cycle-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.5 17.21C14.2059 17.21 17.2101 14.2059 17.2101 10.5C17.2101 6.79422 14.2059 3.79004 10.5 3.79004C6.7942 3.79004 3.79004 6.79422 3.79004 10.5C3.79004 14.2059 6.7942 17.21 10.5 17.21Z" fill="var(--color-brand)" fill-opacity=".35"></path>
                  <path d="M10.5 4.5C12.0913 4.5 13.6174 5.13214 14.7426 6.25735C15.8678 7.38257 16.5 8.9087 16.5 10.5C16.5 12.0913 15.8678 13.6174 14.7426 14.7426C13.6174 15.8679 12.0913 16.5 10.5 16.5C8.9087 16.5 7.38257 15.8679 6.25735 14.7426C5.13214 13.6174 4.5 12.0913 4.5 10.5C4.5 8.9087 5.13214 7.38257 6.25735 6.25735C7.38257 5.13214 8.9087 4.5 10.5 4.5ZM10.5 2C8.24647 2.00265 6.08599 2.89904 4.49251 4.49252C2.89902 6.08601 2.00265 8.24647 2 10.5C2 11.6162 2.21985 12.7215 2.64702 13.7528C3.07418 14.7841 3.7003 15.7211 4.48959 16.5104C5.27889 17.2997 6.21592 17.9258 7.24719 18.353C8.27846 18.7801 9.38376 19 10.5 19C11.6166 19.0013 12.7225 18.7824 13.7544 18.3557C14.7862 17.929 15.7238 17.3029 16.5133 16.5133C17.3029 15.7238 17.929 14.7862 18.3557 13.7544C18.7824 12.7225 19.0013 11.6166 19 10.5C19 8.24566 18.1045 6.08365 16.5104 4.48959C14.9163 2.89553 12.7543 2 10.5 2Z" fill="var(--color-brand)"></path>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M16.4852 14.7068L21.8852 20.1168L20.1158 21.8829L14.7158 16.4729L16.4852 14.7068Z" fill="var(--color-brand)"></path>
                </svg>
              </span>
              <div class="cycle-body">
                <h4 data-i18n="skillcertify-process-item-title-03" v-html="$rt('skillcertify-process-item-title-03')"></h4>
                <p class="desc-sm" data-i18n="skillcertify-process-item-desc-03" v-html="$rt('skillcertify-process-item-desc-03')"></p>
              </div>
              <span class="cycle-arrow" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
              </span>
            </li>
            <li class="blue">
              <span class="cycle-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 15H3C2.44772 15 2 15.4477 2 16V20C2 20.5523 2.44772 21 3 21H6C6.55228 21 7 20.5523 7 20V16C7 15.4477 6.55228 15 6 15Z" fill="var(--color-brand)" fill-opacity=".35"></path>
                  <path d="M13 9H10C9.44772 9 9 9.44772 9 10V20C9 20.5523 9.44772 21 10 21H13C13.5523 21 14 20.5523 14 20V10C14 9.44772 13.5523 9 13 9Z" fill="var(--color-brand)"></path>
                  <path d="M20 3H17C16.4477 3 16 3.44772 16 4V20C16 20.5523 16.4477 21 17 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3Z" fill="var(--color-brand-dark)"></path>
                </svg>
              </span>
              <div class="cycle-body">
                <h4 data-i18n="skillcertify-process-item-title-04" v-html="$rt('skillcertify-process-item-title-04')"></h4>
                <p class="desc-sm" data-i18n="skillcertify-process-item-desc-04" v-html="$rt('skillcertify-process-item-desc-04')"></p>
              </div>
              <span class="cycle-arrow" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
              </span>
            </li>
            <li class="blue">
              <span class="cycle-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4 4H20C21.1046 4 22 4.89543 22 6V16C22 17.1046 21.1046 18 20 18H12L7 23V18H4C2.89543 18 2 17.1046 2 16V6C2 4.89543 2.89543 4 4 4Z" fill="var(--color-brand)" fill-opacity=".35"></path>
                  <path d="M8.5 9.75H7C6.72386 9.75 6.5 9.97386 6.5 10.25V11.75C6.5 12.0261 6.72386 12.25 7 12.25H8.5C8.77614 12.25 9 12.0261 9 11.75V10.25C9 9.97386 8.77614 9.75 8.5 9.75Z" fill="var(--color-brand)"></path>
                  <path d="M12.75 9.75H11.25C10.9739 9.75 10.75 9.97386 10.75 10.25V11.75C10.75 12.0261 10.9739 12.25 11.25 12.25H12.75C13.0261 12.25 13.25 12.0261 13.25 11.75V10.25C13.25 9.97386 13.0261 9.75 12.75 9.75Z" fill="var(--color-brand)"></path>
                  <path d="M17 9.75H15.5C15.2239 9.75 15 9.97386 15 10.25V11.75C15 12.0261 15.2239 12.25 15.5 12.25H17C17.2761 12.25 17.5 12.0261 17.5 11.75V10.25C17.5 9.97386 17.2761 9.75 17 9.75Z" fill="var(--color-brand)"></path>
                </svg>
              </span>
              <div class="cycle-body">
                <h4 data-i18n="skillcertify-process-item-title-05" v-html="$rt('skillcertify-process-item-title-05')"></h4>
                <p class="desc-sm" data-i18n="skillcertify-process-item-desc-05" v-html="$rt('skillcertify-process-item-desc-05')"></p>
              </div>
            </li>
          </ol>
        </div>
      </div>
    </section>

    <section class="outcomes fade-up">
      <div class="section-wrap col">
        <div class="section-title text-center">
          <p class="mini-title" data-i18n="skillcertify-outcomes-tag" v-html="$rt('skillcertify-outcomes-tag')"></p>
          <h2 data-i18n="skillcertify-outcomes-title" v-html="$rt('skillcertify-outcomes-title')"></h2>
        </div>
        <div class="section-content">
          <ul class="outcome-list">
            <li>
              <div class="outcome-logo">
                <img src="/images/clients/dark/logo-cj.svg" alt="CJ올리브네트웍스 로고" loading="lazy">
              </div>
              <div class="outcome-body">
                <p class="tag sm" data-i18n="skillcertify-outcomes-item-tag-01" v-html="$rt('skillcertify-outcomes-item-tag-01')"></p>
                <p class="outcome-headline" data-i18n="skillcertify-outcomes-item-headline-01" v-html="$rt('skillcertify-outcomes-item-headline-01')"></p>
                <p class="outcome-detail" data-i18n="skillcertify-outcomes-item-detail-01" v-html="$rt('skillcertify-outcomes-item-detail-01')"></p>
                <p class="outcome-client"><span data-i18n="skillcertify-outcomes-item-client-01" v-html="$rt('skillcertify-outcomes-item-client-01')"></span> <span class="outcome-industry" data-i18n="skillcertify-outcomes-item-industry-01" v-html="$rt('skillcertify-outcomes-item-industry-01')"></span></p>
              </div>
            </li>
            <li>
              <div class="outcome-logo">
                <img src="/images/clients/dark/logo-hyundai-mobis.png" alt="현대모비스 로고" loading="lazy">
              </div>
              <div class="outcome-body">
                <p class="tag sm" data-i18n="skillcertify-outcomes-item-tag-02" v-html="$rt('skillcertify-outcomes-item-tag-02')"></p>
                <p class="outcome-headline" data-i18n="skillcertify-outcomes-item-headline-02" v-html="$rt('skillcertify-outcomes-item-headline-02')"></p>
                <p class="outcome-detail" data-i18n="skillcertify-outcomes-item-detail-02" v-html="$rt('skillcertify-outcomes-item-detail-02')"></p>
                <p class="outcome-client"><span data-i18n="skillcertify-outcomes-item-client-02" v-html="$rt('skillcertify-outcomes-item-client-02')"></span> <span class="outcome-industry" data-i18n="skillcertify-outcomes-item-industry-02" v-html="$rt('skillcertify-outcomes-item-industry-02')"></span></p>
              </div>
            </li>
            <li>
              <div class="outcome-logo">
                <img src="/images/clients/dark/logo-skt.png" alt="SK텔레콤 로고" loading="lazy">
              </div>
              <div class="outcome-body">
                <p class="tag sm" data-i18n="skillcertify-outcomes-item-tag-03" v-html="$rt('skillcertify-outcomes-item-tag-03')"></p>
                <p class="outcome-headline" data-i18n="skillcertify-outcomes-item-headline-03" v-html="$rt('skillcertify-outcomes-item-headline-03')"></p>
                <p class="outcome-detail" data-i18n="skillcertify-outcomes-item-detail-03" v-html="$rt('skillcertify-outcomes-item-detail-03')"></p>
                <p class="outcome-client"><span data-i18n="skillcertify-outcomes-item-client-03" v-html="$rt('skillcertify-outcomes-item-client-03')"></span> <span class="outcome-industry" data-i18n="skillcertify-outcomes-item-industry-03" v-html="$rt('skillcertify-outcomes-item-industry-03')"></span></p>
              </div>
            </li>
          </ul>
          <div class="cases-more">
            <a class="btn btn-ghost" href="/cases"><span data-i18n="skillcertify-outcomes-more" v-html="$rt('skillcertify-outcomes-more')"></span><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></a>
          </div>
        </div>
      </div>
    </section>

    <section class="faq fade-up">
      <div class="section-wrap col">
        <div class="section-title text-center">
          <p class="mini-title" data-i18n="skillcertify-faq-tag" v-html="$rt('skillcertify-faq-tag')"></p>
          <h2 data-i18n="skillcertify-faq-title" v-html="$rt('skillcertify-faq-title')"></h2>
        </div>
        <div class="section-content">
          <div class="faq-list">
            <details>
              <summary class="faq-list__question">
                <span data-i18n="skillcertify-faq-question-01" v-html="$rt('skillcertify-faq-question-01')"></span>
                <span class="faq-list__icon" aria-hidden="true">
                  <svg class="icon-sm" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                </span>
              </summary>
              <p class="faq-list__answer" data-i18n="skillcertify-faq-answer-01" v-html="$rt('skillcertify-faq-answer-01')"></p>
            </details>
            <details>
              <summary class="faq-list__question">
                <span data-i18n="skillcertify-faq-question-02" v-html="$rt('skillcertify-faq-question-02')"></span>
                <span class="faq-list__icon" aria-hidden="true">
                  <svg class="icon-sm" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                </span>
              </summary>
              <p class="faq-list__answer" data-i18n="skillcertify-faq-answer-02" v-html="$rt('skillcertify-faq-answer-02')"></p>
            </details>
            <details>
              <summary class="faq-list__question">
                <span data-i18n="skillcertify-faq-question-03" v-html="$rt('skillcertify-faq-question-03')"></span>
                <span class="faq-list__icon" aria-hidden="true">
                  <svg class="icon-sm" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                </span>
              </summary>
              <p class="faq-list__answer" data-i18n="skillcertify-faq-answer-03" v-html="$rt('skillcertify-faq-answer-03')"></p>
            </details>
            <details>
              <summary class="faq-list__question">
                <span data-i18n="skillcertify-faq-question-04" v-html="$rt('skillcertify-faq-question-04')"></span>
                <span class="faq-list__icon" aria-hidden="true">
                  <svg class="icon-sm" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                </span>
              </summary>
              <p class="faq-list__answer" data-i18n="skillcertify-faq-answer-04" v-html="$rt('skillcertify-faq-answer-04')"></p>
            </details>
          </div>
        </div>
      </div>
    </section>

    <section class="cta-final fade-up">
      <div class="section-wrap col cta-final-inner">
        <h2 class="cta-final-title" data-i18n="skillcertify-cta-final-title" v-html="$rt('skillcertify-cta-final-title')"></h2>
        <p class="cta-final-desc" data-i18n="skillcertify-cta-final-desc" v-html="$rt('skillcertify-cta-final-desc')"></p>
        <div class="cta-final-actions">
          <a class="btn btn-primary btn-lg" href="https://codepresso.io/home/contact">
            <span data-i18n="skillcertify-cta-final-cta" v-html="$rt('skillcertify-cta-final-cta')"></span>
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
          </a>
        </div>
      </div>
    </section>
  </main>

  <ClientInteractions :scripts='["js/fade-up.js","js/header-scroll.js","js/nav-menu.js"]' />
</template>

<script setup lang="ts">
import ClientInteractions from '../components/ClientInteractions.vue'
import { useRenewalText } from '../composables/useRenewalText'
import ko from '../data/i18n-dist/Skillcertify/ko.json'
import en from '../data/i18n-dist/Skillcertify/en.json'
import ja from '../data/i18n-dist/Skillcertify/ja.json'
import vi from '../data/i18n-dist/Skillcertify/vi.json'
import es from '../data/i18n-dist/Skillcertify/es.json'

// 문자열은 data/i18n-dist 에서 온다 — 마크업은 키만 들고 있다.
const $rt = useRenewalText({ ko, en, ja, vi, es })
</script>
